import { format, parseISO } from 'date-fns'
import ja from 'date-fns/locale/ja'
import { enUS } from 'date-fns/locale'
import i18next from 'i18next'

/**
 * ロケール別のフォーマットパターンを定義
 */
const FORMAT_PATTERNS = {
  ja: {
    date: 'yyyy年M月d日',
    dateTime: 'yyyy年M月d日 HH:mm'
  },
  en: {
    date: 'yyyy-MM-dd',
    dateTime: 'yyyy-MM-dd HH:mm'
  }
} as const

/**
 * ロケール別のlocaleオブジェクトを定義
 */
const LOCALE_OBJECTS = {
  ja,
  en: enUS
} as const

/**
 * 指定されたロケールの日付フォーマットパターンを取得
 * @param locale - ロケール ('ja' | 'en')
 * @param type - フォーマットタイプ ('date' | 'dateTime')
 * @returns フォーマットパターン
 */
export const getFormatPattern = (locale: string, type: 'date' | 'dateTime' = 'date'): string => {
  const isJapanese = locale === 'ja'
  return isJapanese ? FORMAT_PATTERNS.ja[type] : FORMAT_PATTERNS.en[type]
}

/**
 * 指定されたロケールのdate-fns localeオブジェクトを取得
 * @param locale - ロケール ('ja' | 'en')
 * @returns date-fns locale object
 */
export const getLocaleObject = (locale: string) => {
  return locale === 'ja' ? LOCALE_OBJECTS.ja : LOCALE_OBJECTS.en
}

/**
 * ISO文字列を現在のロケールでフォーマット
 * @param date - ISO形式の日付文字列またはDate オブジェクト
 * @param type - フォーマットタイプ ('date' | 'dateTime') または カスタムパターン
 * @returns フォーマットされた日付文字列
 */
export const formatDate = (
  date: string | Date | undefined,
  type: 'date' | 'dateTime' | string = 'date'
): string => {
  if (date == null || date === '') return ''

  const currentLocale = i18next.language
  // typeが定義済みのキーかカスタムパターンかを判定
  const pattern =
    type === 'date' || type === 'dateTime' ? getFormatPattern(currentLocale, type) : type
  const localeObj = getLocaleObject(currentLocale)

  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date
    return format(dateObj, pattern, { locale: localeObj })
  } catch {
    return ''
  }
}
